import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { KineticLines, Reveal } from "@/components/Reveal";
import { IMG } from "@/lib/images";

const CATEGORIES = ["Ice Creams", "Sundaes", "Waffles", "Milkshakes", "Thickshakes", "Lassi", "Coolers"];
const menuSlug = (name) => name.toLowerCase().replace(/\s+/g, "-");

export default function CategoryRail() {
  return (
    <section className="bg-white py-16 md:py-24" data-testid="discover-section">
      <div className="mx-auto max-w-[1440px] px-5 md:px-10">
        <Reveal>
          <p className="font-mono text-[11px] uppercase tracking-[0.28em] text-orange-rific md:text-xs">The Menu</p>
        </Reveal>
        <KineticLines
          lines={["DISCOVER RIFIC."]}
          className="mt-3 block"
          lineClassName="font-display text-[clamp(2rem,4.2vw,3.25rem)] font-extrabold leading-[1.05] tracking-[-0.01em] text-deep"
        />

        <Reveal className="mt-10 md:mt-14">
          <div className="overflow-hidden rounded-[28px] bg-cream">
            <img
              src={IMG.productUniverse}
              srcSet={`${IMG.productUniverse} 1672w, ${IMG.productUniverseM} 900w`}
              sizes="(min-width: 768px) 90vw, 100vw"
              alt="The RIFIC product universe — real fruit ice cream, desserts and shakes"
              loading="lazy"
              className="h-auto w-full object-contain"
            />
          </div>
        </Reveal>

        <div className="grid sm:grid-cols-2 gap-x-8 mt-10 md:mt-14" data-testid="category-rail">
          {CATEGORIES.map((name, i) => (
            <Reveal key={name} delay={i * 0.05}>
              <Link
                to={`/menu#cat-${menuSlug(name)}`}
                data-testid={`category-${menuSlug(name)}-card`}
                className="group flex items-center justify-between border-t border-cream-line py-5 last:border-b md:py-6"
                aria-label={`Explore ${name}`}
              >
                <span className="flex items-baseline gap-5 md:gap-8">
                  <span className="font-mono text-xs text-orange-rific">0{i + 1}</span>
                  <h3 className="font-display text-[clamp(1.5rem,2.2vw,1.875rem)] font-bold uppercase tracking-[-0.01em] text-deep transition-transform duration-300 group-hover:translate-x-2">
                    {name}
                  </h3>
                </span>
                <ArrowUpRight className="h-6 w-6 shrink-0 text-orange-rific transition-transform duration-300 group-hover:-translate-y-1 group-hover:translate-x-1" />
              </Link>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
